import { productPriceStyles } from "@insite/content-library/Components/ProductPrice";
import { css } from "styled-components";

productPriceStyles.packLabelText = {
    css: css`
        color: #888888;
        font-weight: 500;
    `,
};

productPriceStyles.packDescriptionText = {
    css: css`
        color: #888888;
        font-weight: 500;
    `,
};
